module.exports = __webpack_public_path__ + "static/media/fa-light-300.1b7d9530.ttf";